import { ActionCreatorWithOptionalPayload } from '@reduxjs/toolkit';
import { RootState, AppDispatch } from '../store/Store';

/**
 * Wraps a Redux action creator to include additional data from the root state in the action payload.
 * Pulls generic information from the root state that is required for the wrapped action so that callers do not have to 
 * put that info in the payload.
 * 
 * @param sliceAction The action to wrap.
 * @param extractFromState Return all keys from the RootState that should be included in the action payload.
 * @returns 
 */
export function actionWithRootState<TPayload, TExtractedData extends Partial<TPayload>>(
	sliceAction: ActionCreatorWithOptionalPayload<TPayload>,
	extractFromState: (state: RootState) => TExtractedData
)
{
	return (payload: Omit<TPayload, keyof TExtractedData>) => 
	{
		return ((dispatch: AppDispatch, getState: () => RootState) => 
		{
			const state = getState();
			const extractedData = extractFromState(state);
      
			dispatch(sliceAction({
				...payload,
				...extractedData,
			} as unknown as TPayload));
		});
	};
}